import React, { useEffect, useState } from "react";

const AppToast = ({ message, duration = 4000, onClose }) => {
  const [visible, setVisible] = useState(false);
  const fadeDuration = 2000; // 페이드 인/아웃 애니메이션 지속 시간 (ms)

  useEffect(() => {
    setVisible(true);

    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, duration - fadeDuration);

    const closeTimer = setTimeout(() => {
      onClose && onClose();
    }, duration);

    return () => {
      clearTimeout(hideTimer);
      clearTimeout(closeTimer);
    };
  }, [duration, onClose]);

  return (
    <div
      className={`
        fixed bottom-20
        w-[70vw] left-1/2 transform -translate-x-1/2
        px-6 py-3
        bg-neutral-600 text-white
        rounded-lg shadow-lg z-50
        text-center
        text-[3.5vw] transition-opacity duration-[${fadeDuration}ms]
        ${visible ? "opacity-100" : "opacity-0"}
      `}
    >
      {message}
    </div>
  );
};

export default AppToast;
